import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const LockClosedFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 4C6.95139 4 6.0823 4.02992 5.36285 4.11965C5.48279 3.48272 5.66938 2.91606 5.92399 2.45777C6.36972 1.65546 6.99862 1.2 8 1.2C9.00138 1.2 9.63028 1.65546 10.076 2.45777C10.3306 2.91606 10.5172 3.48272 10.6371 4.11965C9.9177 4.02992 9.04861 4 8 4ZM2 10C2 6.50476 2.33243 5.00409 4.10386 4.39139C4.42671 2.01375 5.5421 0 8 0C10.4579 0 11.5733 2.01375 11.8961 4.39139C13.6676 5.00409 14 6.50476 14 10C14 15.25 13.25 16 8 16C2.75 16 2 15.25 2 10ZM7.40002 11.6667H8.60002V8.33333H7.40002V11.6667Z", fill: "var(--magritte-ui-icon-color)" }) }));
const LockClosedFilledSize16 = hoc(forwardRef(LockClosedFilledSize16Component), 'LockClosedFilledSize16');

export { LockClosedFilledSize16 as default };
//# sourceMappingURL=LockClosedFilledSize16.js.map
